import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import amber from '@material-ui/core/colors/amber';

const styles = theme => ({
  root: {
    margin: theme.spacing.unit,
  },
  avatar: {
    margin: theme.spacing.unit*2,
    color: '#fff',
    backgroundColor: amber[500],
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  totals: {
    padding: '30px 30px 50px 0px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  totalsBalance: {
    paddingRight: '25px',
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
});

const InvoiceSummary = ({ classes, invoice }) => {
  return (
    <Card className={classes.root}>
      <div className={classes.header}>
        <Avatar className={classes.avatar}>S</Avatar>
        <Typography variant="headline">Summary</Typography>
      </div>
      <div className={classes.totals}>
        <div>
          <div className={classes.labelField}>
            <Typography variant="subheading">Subtotal</Typography>
            <Typography variant="subheading">${invoice.total.toFixed(2)}</Typography>
          </div>
          <div className={classes.labelField}>
            <Typography variant="subheading">GST</Typography>
            <Typography variant="subheading">${invoice.gst.toFixed(2)}</Typography>
          </div>
          <div className={classes.labelField}>
            <Typography variant="subheading">PST</Typography>
            <Typography variant="subheading">${invoice.pst.toFixed(2)}</Typography>
          </div>
          <hr />
          <div className={classes.labelField}>
            <Typography className={classes.totalsBalance} variant="subheading">Total</Typography>
            <Typography variant="subheading">${invoice.grandTotal.toFixed(2)}</Typography>
          </div>
          <div className={classes.labelField}>
            <Typography className={classes.totalsBalance} variant="subheading">Amount Paid</Typography>
            <Typography variant="subheading">${invoice.paymentTotal.toFixed(2)}</Typography>
          </div>
          <hr />
          <hr />
          <div className={classes.labelField}>
            <Typography className={classes.totalsBalance} variant="title">Amount Due</Typography>
            <Typography variant="title">${invoice.balance.toFixed(2)}</Typography>
          </div>
        </div>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => {
  const invoice = state.invoicesState.find(invoice => invoice.id === state.adminState.invoice.id);

  return {
    invoice: invoice
  }
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(InvoiceSummary);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/InvoiceSummary.jsx